export default [{name:"Afghanistan",code:"af"},
{name:"Albania",code:"al"},
{name:"Algeria",code:"dz"},
{name:"Andorra",code:"ad"},
{name:"Angola",code:"ao"},
{name:"Anguilla",code:"ai"},
{name:"Antartide",code:"aq"},
{name:"Antigua e Barbuda",code:"ag"},
{name:"Arabia Saudita",code:"sa"},
{name:"Argentina",code:"ar"},
{name:"Armenia",code:"am"},
{name:"Aruba",code:"aw"},
{name:"Australia",code:"au"},
{name:"Austria",code:"at"},
{name:"Azerbaigian",code:"az"},
{name:"Bahamas",code:"bs"},
{name:"Bahrein",code:"bh"},
{name:"Bangladesh",code:"bd"},
{name:"Barbados",code:"bb"},
{name:"Belgio",code:"be"},
{name:"Belize",code:"bz"},
{name:"Benin",code:"bj"},
{name:"Bermuda",code:"bm"},
{name:"Bhutan",code:"bt"},
{name:"Bielorussia",code:"by"},
{name:"Birmania",code:"mm"},
{name:"Bolivia",code:"bo"},
{name:"Bosnia ed Erzegovina",code:"ba"},
{name:"Botswana",code:"bw"},
{name:"Brasile",code:"br"},
{name:"Brunei",code:"bn"},
{name:"Bulgaria",code:"bg"},
{name:"Burkina Faso",code:"bf"},
{name:"Burundi",code:"bi"},
{name:"Cambogia",code:"kh"},
{name:"Camerun",code:"cm"},
{name:"Canada",code:"ca"},
{name:"Capo Verde",code:"cv"},
{name:"Ciad",code:"td"},
{name:"Cile",code:"cl"},
{name:"Cina",code:"cn"},
{name:"Cipro",code:"cy"},
{name:"Città del Vaticano",code:"va"},
{name:"Colombia",code:"co"},
{name:"Comore",code:"km"},
{name:"Corea del Nord",code:"kp"},
{name:"Corea del Sud",code:"kr"},
{name:"Costa d'Avorio",code:"ci"},
{name:"Costa Rica",code:"cr"},
{name:"Croazia",code:"hr"},
{name:"Cuba",code:"cu"},
{name:"Curaçao",code:"cw"},
{name:"Danimarca",code:"dk"},
{name:"Dominica",code:"dm"},
{name:"Ecuador",code:"ec"},
{name:"Egitto",code:"eg"},
{name:"El Salvador",code:"sv"},
{name:"Emirati Arabi Uniti",code:"ae"},
{name:"Eritrea",code:"er"},
{name:"Estonia",code:"ee"},
{name:"Etiopia",code:"et"},
{name:"Figi",code:"fj"},
{name:"Filippine",code:"ph"},
{name:"Finlandia",code:"fi"},
{name:"Francia",code:"fr"},
{name:"Gabon",code:"ga"},
{name:"Gambia",code:"gm"},
{name:"Georgia",code:"ge"},
{name:"Georgia del Sud e Isole Sandwich Australi",code:"gs"},
{name:"Germania",code:"de"},
{name:"Ghana",code:"gh"},
{name:"Giamaica",code:"jm"},
{name:"Giappone",code:"jp"},
{name:"Gibilterra",code:"gi"},
{name:"Gibuti",code:"dj"},
{name:"Giordania",code:"jo"},
{name:"Grecia",code:"gr"},
{name:"Grenada",code:"gd"},
{name:"Groenlandia",code:"gl"},
{name:"Guadalupa",code:"gp"},
{name:"Guam",code:"gu"},
{name:"Guatemala",code:"gt"},
{name:"Guernsey",code:"gg"},
{name:"Guinea",code:"gn"},
{name:"Guinea-Bissau",code:"gw"},
{name:"Guinea Equatoriale",code:"gq"},
{name:"Guyana",code:"gy"},
{name:"Guyana francese",code:"gf"},
{name:"Haiti",code:"ht"},
{name:"Honduras",code:"hn"},
{name:"Hong Kong",code:"hk"},
{name:"India",code:"in"},
{name:"Indonesia",code:"id"},
{name:"Iran",code:"ir"},
{name:"Iraq",code:"iq"},
{name:"Irlanda",code:"ie"},
{name:"Islanda",code:"is"},
{name:"Isola Bouvet",code:"bv"},
{name:"Isola di Man",code:"im"},
{name:"Isola di Natale",code:"cx"},
{name:"Isola Norfolk",code:"nf"},
{name:"Isole Åland",code:"ax"},
{name:"Isole BES",code:"bq"},
{name:"Isole Cayman",code:"ky"},
{name:"Isole Cocos (Keeling)",code:"cc"},
{name:"Isole Cook",code:"ck"},
{name:"Fær Øer",code:"fo"},
{name:"Isole Falkland",code:"fk"},
{name:"Isole Heard e McDonald",code:"hm"},
{name:"Isole Marianne Settentrionali",code:"mp"},
{name:"Isole Marshall",code:"mh"},
{name:"Isole minori esterne degli Stati Uniti",code:"um"},
{name:"Isole Pitcairn",code:"pn"},
{name:"Isole Salomone",code:"sb"},
{name:"Isole Vergini britanniche",code:"vg"},
{name:"Isole Vergini americane",code:"vi"},
{name:"Israele",code:"il"},
{name:"Italia",code:"it"},
{name:"Jersey",code:"je"},
{name:"Kazakistan",code:"kz"},
{name:"Kenya",code:"ke"},
{name:"Kirghizistan",code:"kg"},
{name:"Kiribati",code:"ki"},
{name:"Kuwait",code:"kw"},
{name:"Laos",code:"la"},
{name:"Lesotho",code:"ls"},
{name:"Lettonia",code:"lv"},
{name:"Libano",code:"lb"},
{name:"Liberia",code:"lr"},
{name:"Libia",code:"ly"},
{name:"Liechtenstein",code:"li"},
{name:"Lituania",code:"lt"},
{name:"Lussemburgo",code:"lu"},
{name:"Macao",code:"mo"},
{name:"Macedonia del Nord",code:"mk"},
{name:"Madagascar",code:"mg"},
{name:"Malawi",code:"mw"},
{name:"Malaysia",code:"my"},
{name:"Maldive",code:"mv"},
{name:"Mali",code:"ml"},
{name:"Malta",code:"mt"},
{name:"Marocco",code:"ma"},
{name:"Martinica",code:"mq"},
{name:"Mauritania",code:"mr"},
{name:"Mauritius",code:"mu"},
{name:"Mayotte",code:"yt"},
{name:"Messico",code:"mx"},
{name:"Micronesia",code:"fm"},
{name:"Moldavia",code:"md"},
{name:"Mongolia",code:"mn"},
{name:"Montenegro",code:"me"},
{name:"Montserrat",code:"ms"},
{name:"Mozambico",code:"mz"},
{name:"Namibia",code:"na"},
{name:"Nauru",code:"nr"},
{name:"Nepal",code:"np"},
{name:"Nicaragua",code:"ni"},
{name:"Niger",code:"ne"},
{name:"Nigeria",code:"ng"},
{name:"Niue",code:"nu"},
{name:"Norvegia",code:"no"},
{name:"Nuova Caledonia",code:"nc"},
{name:"Nuova Zelanda",code:"nz"},
{name:"Oman",code:"om"},
{name:"Paesi Bassi",code:"nl"},
{name:"Pakistan",code:"pk"},
{name:"Palau",code:"pw"},
{name:"Palestina",code:"ps"},
{name:"Panama",code:"pa"},
{name:"Papua Nuova Guinea",code:"pg"},
{name:"Paraguay",code:"py"},
{name:"Perù",code:"pe"},
{name:"Polinesia francese",code:"pf"},
{name:"Polonia",code:"pl"},
{name:"Porto Rico",code:"pr"},
{name:"Portogallo",code:"pt"},
{name:"Monaco",code:"mc"},
{name:"Qatar",code:"qa"},
{name:"Regno Unito",code:"gb"},
{name:"RD del Congo",code:"cd"},
{name:"Rep. Ceca",code:"cz"},
{name:"Rep. Centrafricana",code:"cf"},
{name:"Rep. del Congo",code:"cg"},
{name:"Rep. Dominicana",code:"do"},
{name:"Riunione",code:"re"},
{name:"Romania",code:"ro"},
{name:"Ruanda",code:"rw"},
{name:"Russia",code:"ru"},
{name:"Sahara Occidentale",code:"eh"},
{name:"Saint Kitts e Nevis",code:"kn"},
{name:"Saint Lucia",code:"lc"},
{name:"Sant'Elena, Ascensione e Tristan da Cunha",code:"sh"},
{name:"Saint Vincent e Grenadine",code:"vc"},
{name:"Saint-Barthélemy",code:"bl"},
{name:"Saint-Martin",code:"mf"},
{name:"Saint-Pierre e Miquelon",code:"pm"},
{name:"Samoa",code:"ws"},
{name:"Samoa Americane",code:"as"},
{name:"San Marino",code:"sm"},
{name:"São Tomé e Príncipe",code:"st"},
{name:"Senegal",code:"sn"},
{name:"Serbia",code:"rs"},
{name:"Seychelles",code:"sc"},
{name:"Sierra Leone",code:"sl"},
{name:"Singapore",code:"sg"},
{name:"Sint Maarten",code:"sx"},
{name:"Siria",code:"sy"},
{name:"Slovacchia",code:"sk"},
{name:"Slovenia",code:"si"},
{name:"Somalia",code:"so"},
{name:"Spagna",code:"es"},
{name:"Sri Lanka",code:"lk"},
{name:"Stati Uniti",code:"us"},
{name:"Sudafrica",code:"za"},
{name:"Sudan",code:"sd"},
{name:"Sudan del Sud",code:"ss"},
{name:"Suriname",code:"sr"},
{name:"Svalbard e Jan Mayen",code:"sj"},
{name:"Svezia",code:"se"},
{name:"Svizzera",code:"ch"},
{name:"Swaziland",code:"sz"},
{name:"Taiwan",code:"tw"},
{name:"Tagikistan",code:"tj"},
{name:"Tanzania",code:"tz"},
{name:"Terre australi e antartiche francesi",code:"tf"},
{name:"Territorio britannico dell'Oceano Indiano",code:"io"},
{name:"Thailandia",code:"th"},
{name:"Timor Est",code:"tl"},
{name:"Togo",code:"tg"},
{name:"Tokelau",code:"tk"},
{name:"Tonga",code:"to"},
{name:"Trinidad e Tobago",code:"tt"},
{name:"Tunisia",code:"tn"},
{name:"Turchia",code:"tr"},
{name:"Turkmenistan",code:"tm"},
{name:"Turks e Caicos",code:"tc"},
{name:"Tuvalu",code:"tv"},
{name:"Ucraina",code:"ua"},
{name:"Uganda",code:"ug"},
{name:"Ungheria",code:"hu"},
{name:"Uruguay",code:"uy"},
{name:"Uzbekistan",code:"uz"},
{name:"Vanuatu",code:"vu"},
{name:"Venezuela",code:"ve"},
{name:"Vietnam",code:"vn"},
{name:"Wallis e Futuna",code:"wf"},
{name:"Yemen",code:"ye"},
{name:"Zambia",code:"zm"},
{name:"Zimbabwe",code:"zw"}]